import React from "react";
import PropTypes from "prop-types";
import FinalStep from "./FinalStep";
import ContactDetailsStep from "./ContactDetailsStep";
import DocumentUploadStep from "./DocumentUploadStep";
import IntermediateStep from "./IntermediateStep";
import Question from "./Question";

const Steps = ({ wizard = {}, onSubmit }) => {
  const { questions, message, description, stepKey, machineAnswers } = wizard;
  const [question] = questions;

  switch (stepKey) {
    case "RESULT_PARKING":
    case "RESULT_ACCIDENT":
    case "RESULT_PAGE_INSURED":
    case "RESULT_PAGE_NOT_INSURED":
      return (
        <FinalStep
          message={question.message}
          description={question.description}
        />
      );
    case "UPLOAD_DOCUMENTS":
      return (
        <DocumentUploadStep
          message={message}
          description={description}
          question={question}
          onSubmit={onSubmit}
        />
      );
    case "CONTACT_DETAILS":
      return (
        <ContactDetailsStep
          message={message}
          machineAnswers={machineAnswers}
          questions={questions}
          onSubmit={onSubmit}
        />
      );
    case "THANK_YOU":
      return (
        <IntermediateStep
          message={question.message}
          description={question.description}
        />
      );
    default:
      return questions.map((question) => (
        <Question key={question.key} question={question} onSubmit={onSubmit} />
      ));
  }
};

Steps.propTypes = {
  wizard: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Steps;
